import { render } from "./OurPricing.vue?vue&type=template&id=0fc728ff&ts=true"
import script from "./OurPricing.vue?vue&type=script&lang=ts"
export * from "./OurPricing.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__